var ls_responsive_tables = {
    selector: 'table',
    class: 'table-responsive',
    init: function(){
        var tables = jQuery(this.selector);
        if(tables.length > 0){
            tables.each(function(){
                $this = jQuery(this);
                $this.addClass(ls_responsive_tables.class);
                $labels = $this.find('thead > tr > th, thead > tr > td');
                $rows = $this.find('tbody > tr');
                $rows.each(function(){
                    $row = jQuery(this);
                    $cells = $row.find('td');
                    $cells.each(function(index){
                        $cell = jQuery(this);
                        $cell.attr('data-label', $labels.eq(index).text());
                        $cell.css('height', 'auto');
                    });
                });
            });
        }
    }
};

jQuery(document).ready(function(){
    ls_responsive_tables.init();
});